// Дополнительные русские строки. Объединяются с базовым словарём в LanguageContext.
export const ru: Record<string, string> = {
  'common.close': 'Закрыть',
  'common.close_window': 'Закрыть окно',
  'common.confirm': 'Подтвердить',
  'common.delete': 'Удалить',
  'common.retry': 'Повторить',
  'common.reset': 'Сбросить',
  'common.loading': 'Загрузка…',
  'common.empty': 'Ничего не найдено',
  'common.error_generic': 'Не удалось выполнить запрос',
  'common.menu': 'Меню',
  'common.premium': 'Premium',
  'common.skip_to_content': 'Перейти к содержимому',
  'common.main_nav': 'Основная навигация',
  'common.type_to_confirm': 'Введите «{value}» для подтверждения',
  'dialog.discard_title': 'Закрыть без сохранения?',
  'dialog.discard_text': 'Несохранённые изменения будут потеряны.',
  'dialog.discard': 'Отменить изменения',
  'dialog.keep_editing': 'Продолжить',
  'sidebar.anticheat': 'Скачать античит',
  'sidebar.anticheat_hint': 'Требуется для игры в матчах',
  'header.close_notifications': 'Закрыть уведомления',
  'header.delete_notification': 'Удалить уведомление',
  'header.account_menu': 'Меню аккаунта',
  'header.switch_language': 'Сменить язык',
  'stats.export_done': 'Файл со страницей истории скачан',
  'stats.refreshed': 'Данные обновлены',
  'skins.add': 'Добавить скин',
  'skins.add_title': 'Добавить скин',
  'skins.configure': 'Настроить скин',
  'skins.kind': 'Тип предмета',
  'skins.kind.weapon': 'Оружие',
  'skins.kind.knife': 'Ножи',
  'skins.kind.glove': 'Перчатки',
  'skins.model': 'Модель',
  'skins.all_models': 'Все модели',
  'skins.search_name': 'Поиск по названию…',
  'skins.search_sticker': 'Поиск наклейки…',
  'skins.search_charm': 'Поиск брелока…',
  'skins.active_filters': 'Активные фильтры',
  'skins.remove_filter': 'Убрать фильтр «{value}»',
  'skins.catalog_error': 'Не удалось загрузить каталог',
  'skins.nothing_found': 'Ничего не найдено',
  'skins.nothing_found_for': 'По запросу «{value}» предметов нет.',
  'skins.clear_search': 'Очистить поиск',
  'skins.range': '{from}–{to} из {total}',
  'skins.side': 'Сторона',
  'skins.wear': 'Состояние',
  'skins.wear.factory_new': 'Прямо с завода',
  'skins.wear.minimal_wear': 'Немного поношенное',
  'skins.wear.field_tested': 'После полевых испытаний',
  'skins.wear.well_worn': 'Поношенное',
  'skins.wear.battle_scarred': 'Закалённое в боях',
  'skins.decorations': 'Украшения',
  'skins.stickers': 'Наклейки',
  'skins.charm': 'Брелок',
  'skins.sticker': 'Наклейка',
  'skins.slot': 'Слот {n}',
  'skins.slot_add': 'Добавить наклейку в слот {n}',
  'skins.slot_replace': 'Слот {n}: {name}. Заменить',
  'skins.slot_remove': 'Снять наклейку из слота {n}',
  'skins.charm_add': 'Добавить брелок',
  'skins.charm_replace': 'Брелок: {name}. Заменить',
  'skins.charm_remove': 'Снять брелок',
  'skins.pick_sticker': 'Наклейка · слот {n}',
  'skins.pick_charm': 'Брелок',
  'skins.back_to_catalog': 'К каталогу',
  'skins.need_premium': 'Для сохранения скинов нужен Premium.',
  'skins.saving': 'Сохраняем…',
  'skins.save_apply': 'Сохранить изменения',
  'skins.add_apply': 'Добавить в инвентарь',
  'skins.saved': 'Набор сохранён',
  'skins.deleted': 'Предмет удалён',
  'skins.load_error': 'Не удалось загрузить инвентарь',
  'skins.empty_title': 'Собери свой первый набор',
  'skins.empty_text': 'Добавьте оружие, нож или перчатки, выберите сторону и украшения — набор применится в матчах.',
  'skins.not_in_game': 'Не выбран для игры',
  'skins.search_inventory': 'Поиск по инвентарю',
  'skins.kind_all': 'Все типы',
  'skins.side_t_short': 'Террористы',
  'skins.side_ct_short': 'Спецназ',
  'skins.side_required': 'Выберите хотя бы одну сторону.',
  'skins.filter_all': 'Все',
  'skins.filter_none': 'Не экипированы',
  'skins.filter_label': 'Сторона',
  'skins.loadout_title': 'Экипировка: {side}',
  'skins.loadout_knife': 'Нож',
  'skins.loadout_gloves': 'Перчатки',
  'skins.loadout_weapons': 'Оружие',
  'skins.loadout_empty': 'Не выбрано',
  'skins.loadout_weapons_count': '{n} шт.',
  'skins.side_empty_title': 'Для этой стороны ничего не выбрано',
  'skins.side_empty_text': 'Откройте вкладку «Все» и нажмите «Экипировать» на нужном предмете.',
  'skins.none_empty_title': 'Все предметы назначены',
  'skins.none_empty_text': 'Каждый предмет экипирован хотя бы за одну сторону.',
  'skins.delete': 'Удалить из набора',
  'skins.delete_title': 'Удалить предмет из инвентаря?',
  'skins.delete_text': 'Предмет, его наклейки и брелок исчезнут из вашего набора CS Hub, а сторона освободится. Скины в Steam это не затрагивает. Добавить предмет можно заново из каталога.',
  'skins.rarity.consumer': 'Ширпотреб',
  'skins.rarity.industrial': 'Промышленное',
  'skins.rarity.milspec': 'Армейское',
  'skins.rarity.restricted': 'Запрещённое',
  'skins.rarity.classified': 'Засекреченное',
  'skins.rarity.covert': 'Тайное',
  'skins.rarity.contraband': 'Контрабанда',
  'skins.rarity.special': 'Особый предмет',
  'common.saved': 'Сохранено',
  'home.mode': '5×5 · Россия',
  'home.team': 'Команда',
  'home.history': 'История матчей',
  'home.all_stats': 'Вся статистика',
  'home.history_error': 'Не удалось загрузить историю',
  'home.history_empty': 'Матчей пока нет',
  'home.history_empty_text': 'Результат первого завершённого матча появится здесь',
  'home.map_none': 'Карта не выбрана',
  'home.show_more': 'Показать ещё',
  'home.result.win': 'Победа',
  'home.result.loss': 'Поражение',
  'home.result.draw': 'Ничья',
  'home.result.pending': 'Идёт',
  'home.sync_error': 'Не удалось обновить поиск. Повторяем соединение…',
  'home.search_players': 'Поиск игроков',
  'home.search_placeholder': 'Найти игрока по нику…',
  'home.search_none': 'Игроки не найдены.',
  'home.search_hint': 'Поиск по всем игрокам. Добавьте в друзья, чтобы приглашать их в команду.',
  'home.add_friend': 'Добавить в друзья',
  'home.add_friend_named': 'Добавить в друзья: {name}',
  'home.invite_team': 'Пригласить в команду',
  'home.invite_named': 'Пригласить в команду: {name}',
  'home.remove_friend': 'Удалить из друзей',
  'home.remove_named': 'Удалить из друзей: {name}',
  'home.need_steam': 'Привяжите Steam, чтобы начать играть.',
  'home.link_steam': 'Привязать Steam',
  'home.searching': 'Ищем соперников',
  'home.sec': 'сек.',
  'home.sound_on': 'Включить звук',
  'home.sound_off': 'Выключить звук',
  'home.cancelling': 'Отменяем поиск…',
  'home.cancel_search': 'Отменить поиск',
  'home.waiting_ready': 'Ждём готовности участников',
  'home.ready_to_search': 'Команда готова — можно искать матч.',
  'home.confirm_ready': 'Подтвердите готовность',
  'home.search_starting': 'Начинаем поиск…',
  'home.debug_mode': 'Дебаг режим (Dev): поиск 10 сек, остальные боты',
  'home.find_match': 'Найти матч',
  'home.not_ready': 'Не готов',
  'home.im_ready': 'Я готов',
  'home.leader': 'Лидер',
  'home.ready': 'Готов',
  'home.steam_needed': 'Нужен Steam',
  'home.make_leader': 'Передать лидерство',
  'home.make_leader_named': 'Назначить лидером: {name}',
  'home.kick': 'Исключить',
  'home.kick_named': 'Исключить: {name}',
  'home.invite_player': 'Пригласить игрока',
  'home.leave': 'Выйти из команды',
  'home.invitation': 'Приглашение',
  'home.invitation_text': '{name} зовёт вас в команду',
  'home.join': 'Присоединиться',
  'home.readiness': 'Готовность к игре',
  'home.steam_linked': 'Steam привязан',
  'home.steam_not_linked': 'Steam не привязан',
  'home.gameguard': 'Античит GameGuard',
  'home.gameguard_hint': 'Нужен для матчей. Сайт не может проверить установку автоматически.',
  'home.team_count': 'В команде: {n} из 5',
  'home.friends': 'Друзья',
  'home.friend_requests': 'Запросы в друзья',
  'home.accept_friend': 'Принять',
  'home.accept_friend_named': 'Принять в друзья: {name}',
  'home.decline': 'Отклонить',
  'home.decline_named': 'Отклонить запрос: {name}',
  'home.status.in_game': 'Играют',
  'home.status.online': 'В сети',
  'home.status.offline': 'Не в сети',
  'home.no_friends': 'Друзей пока нет',
  'home.invite_hint': 'Выберите друга или найдите игрока. Чтобы пригласить найденного игрока, сначала добавьте его в друзья.',
  'home.no_friends_invite': 'Друзей пока нет — найдите игрока ниже и отправьте ему запрос.',
  'home.find_players': 'Найти игроков',
  'home.invite': 'Пригласить',
  'home.remove_title': 'Удалить из друзей?',
  'home.remove_text': 'Игрок исчезнет из списка друзей. Дружбу можно восстановить новым запросом.',
  'home.keep': 'Оставить',
  'home.removed': 'Удалён из друзей',
  'steam.connecting': 'Подключаем Steam',
  'steam.connecting_text': 'Подтверждаем игровой аккаунт. Это займёт несколько секунд.',
  'steam.checking': 'Проверка аккаунта',
  'steam.retry_needed': 'Нужно повторить',
  'steam.conflict.title': 'Этот Steam уже привязан',
  'steam.conflict.text': 'Этот аккаунт Steam уже используется в другом профиле CS Hub. Войдите в тот профиль или привяжите другой Steam.',
  'steam.expired.title': 'Сессия Steam истекла',
  'steam.expired.text': 'Подтверждение заняло слишком много времени. Попробуйте ещё раз.',
  'steam.invalid.title': 'Steam не подтвердил вход',
  'steam.invalid.text': 'Ответ Steam не прошёл проверку. Повторите вход.',
  'steam.unavailable.title': 'Steam недоступен',
  'steam.unavailable.text': 'Сервис Steam сейчас не отвечает. Повторите попытку через несколько минут.',
  'steam.failed.title': 'Не удалось подключить Steam',
  'steam.failed.text': 'Что-то пошло не так. Повторите попытку или обратитесь в поддержку.',
  'steam.back_profile': 'Вернуться в профиль',
  'steam.back_login': 'Вернуться ко входу',
  'steam.other_account': 'Использовать другой Steam',
  'steam.contact_support': 'Обратиться в поддержку',
  'stats.export_page': 'Экспорт страницы',
  'stats.filter.only_draws': 'Только ничьи',
  'stats.scope': 'Фильтры и поиск применяются к показателям, графикам и истории. Период: {period}.',
  'stats.summary_error': 'Не удалось загрузить показатели',
  'stats.elo_summary': 'ELO изменилось с {from} до {to} за {n} точек.',
  'stats.activity_summary': 'Всего матчей: {n} за {days} дней с активностью.',
  'stats.table.empty': 'Матчей не найдено',
  'stats.table.empty_for': 'По запросу «{value}» ничего нет. Измените фильтры или очистите поиск.',
  'stats.open_match': 'Открыть матч',
  'match.back_history': 'К истории матчей',
  'match.load_error': 'Не удалось загрузить матч',
  'match.to_home': 'На главную',
  'match.loading': 'Загружаем матч…',
  'match.region': 'Россия',
  'match.score': 'Итоговый счёт',
  'match.phase.voting': 'Голосование',
  'match.phase.starting': 'Сервер готовится',
  'match.phase.running': 'Подключение',
  'match.phase.finished': 'Завершён',
  'match.phase.cancelled': 'Отменён',
  'match.phase.error': 'Ошибка запуска',
  'match.turn': 'Ход: {team} · {sec} сек.',
  'match.vote_hint': 'Исключите карту, которую не хотите играть. Голос можно изменить до конца хода.',
  'match.leave_cancel': 'Выйти из команды и отменить матч',
  'match.ban': 'Исключить карту',
  'match.server': 'Сервер',
  'match.password': 'Пароль',
  'match.no_password': 'без пароля',
  'match.copied': 'Скопировано',
  'match.copy_failed': 'Не удалось скопировать',
  'match.copy': 'Скопировать команду',
  'match.connect': 'Подключиться',
  'match.preparing': 'Сервер готовится. Данные для подключения появятся здесь.',
  'match.found': 'Матч найден',
  'match.prep.title': 'Запускаем ваш сервер',
  'match.prep.elapsed': 'Время ожидания',
  'match.prep.reserve': 'Резервируем игровой сервер',
  'match.prep.boot': 'Запускаем CS2',
  'match.prep.map': 'Загружаем карту {map}',
  'match.prep.plugin': 'Ждём, пока сервер подтвердит готовность',
  'match.prep.hint': 'Обычно это занимает 1–2 минуты. Не закрывайте страницу — данные для подключения появятся здесь сами.',
  'match.prep.kicker': 'Карта матча',
  'match.prep.short.reserve': 'Сервер',
  'match.prep.short.boot': 'Запуск CS2',
  'match.prep.short.map': 'Карта',
  'match.prep.short.plugin': 'Готовность',
  'match.report_server': 'Пожаловаться на сервер',
  'match.report_player': 'Пожаловаться на игрока',
  'match.report_player_named': 'Пожаловаться на игрока {name}',
  'match.report': 'Жалоба',
  'match.reason': 'Причина',
  'match.report_text': 'Что произошло',
  'match.report_placeholder': 'Опишите проблему',
  'match.reason.player.cheating': 'Читы',
  'match.reason.player.abuse': 'Оскорбления',
  'match.reason.player.griefing': 'Саботаж или AFK',
  'match.reason.player.other': 'Другое',
  'match.reason.server.lag': 'Лаги и просадки',
  'match.reason.server.connection': 'Не удаётся подключиться',
  'match.reason.server.other': 'Другое',
  'match.report_sent': 'Жалоба отправлена',
  'match.sending': 'Отправляем…',
  'match.send': 'Отправить',
  'match.your_team': 'ваша команда',
  'match.you': 'вы',
  'match.player': 'Игрок',
  'match.open_profile': 'Открыть профиль',
  'match.open_profile_named': 'Открыть профиль: {name}',
  'match.request_sent': 'Заявка отправлена',
  'match.new': 'Новый матч',
  'profile.tabs.settings': 'Настройки',
  'profile.avatar_failed': 'Не удалось сохранить аватар',
  'profile.background_updated': 'Фон профиля обновлён',
  'profile.background_failed': 'Не удалось сохранить фон',
  'profile.image_rejected': 'Файл не подходит: нужен рисунок JPG, PNG или GIF до 3 МБ.',
  'profile.image_hint': 'JPG, PNG или GIF, до 3 МБ',
  'profile.no_changes': 'Нет изменений для сохранения',
  'profile.username_short': 'Имя должно содержать минимум 2 символа',
  'profile.save_failed': 'Не удалось сохранить профиль',
  'pp.now_friends': 'Теперь вы друзья',
  'pp.request_sent': 'Заявка отправлена',
  'pp.back': 'Назад',
  'pp.not_found': 'Игрок не найден',
  'pp.avatar_of': 'Аватар игрока {name}',
  'pp.sending': 'Отправляем…',
  'pp.already_friends': 'Уже в друзьях',
  'pp.accept': 'Принять заявку',
  'pp.stats': 'Статистика',
  'clans.my_clan_error': 'Не удалось определить ваш клан.',
  'clans.tab.overview': 'Обзор кланов',
  'clans.tab.mine': 'Мой клан',
  'clans.tab.invitations': 'Приглашения',
  'clans.search': 'Поиск кланов…',
  'clans.sort_by': 'Сортировать по',
  'clans.sort.name': 'Название',
  'clans.sort.members': 'Участники',
  'clans.sort.winRate': 'Победы, %',
  'clans.order.asc': 'По возрастанию',
  'clans.order.desc': 'По убыванию',
  'clans.results': 'Кланов: {n}',
  'clans.already_member': 'Вы уже состоите в клане «{name}»',
  'clans.confirm.kick_title': 'Исключить {name}?',
  'clans.confirm.kick_text': 'Игрок потеряет доступ к клану и сможет подать заявку заново.',
  'clans.confirm.kick': 'Исключить',
  'clans.confirm.disband_title': 'Распустить клан «{name}»?',
  'clans.confirm.disband_text': 'Клан и его состав будут удалены. Это действие нельзя отменить.',
  'clans.confirm.disband': 'Распустить клан',
  'clans.confirm.leave_title': 'Покинуть клан «{name}»?',
  'clans.confirm.leave_text': 'Вы перестанете быть участником клана.',
  'clans.confirm.leave': 'Покинуть клан',
  'premium.already_paid': 'Этот заказ уже оплачен',
  'premium.status.succeeded': 'Оплата подтверждена. Премиум активирован.',
  'premium.status.canceled': 'Оплата отменена. Можно выбрать срок и повторить.',
  'premium.status.pending': 'Ожидаем подтверждения оплаты…',
  'premium.status.error': 'Не удалось получить статус оплаты.',
  'premium.renew': 'Продление',
  'premium.term': 'На какой срок',
  'premium.active': 'Премиум активен',
  'premium.active_until': 'Активен до {date}',
  'premium.renew_hint': 'Продление добавится к текущему сроку.',
  'premium.months': '{n} мес.',
  'premium.have_promo': 'Есть промокод',
  'premium.promo': 'Промокод',
  'premium.promo_placeholder': 'Если есть',
  'premium.promo_note': 'Скидка появится в сумме только после проверки кода.',
  'premium.total': 'К оплате за {n} мес.',
  'premium.total_before_promo': 'К оплате за {n} мес. без учёта промокода',
  'premium.preparing': 'Подготавливаем оплату…',
  'premium.pay': 'Перейти к оплате',
  'premium.renew_action': 'Продлить Премиум',
  'premium.need_email': 'Для чека нужен email.',
  'premium.add_email': 'Указать в настройках профиля',
  'premium.pay_error': 'Не удалось перейти к оплате',
  'premium.pay_error_next': 'Попробуйте позже или напишите нам:',
  'premium.secure': 'Оплата через YooKassa. Подписка не продлевается автоматически.',
  'premium.use_title': 'Ваш набор скинов',
  'premium.use_text': 'Премиум активен — настройте оружие, ножи и перчатки для каждой стороны.',
  'premium.open_inventory': 'Открыть инвентарь',
  'premium.headline': 'Свои скины в каждом матче',
  'premium.month': 'месяц',
  'premium.example': 'Пример набора',
  'premium.example_t': 'Набор для атаки',
  'premium.example_ct': 'Набор для защиты',
  'premium.f1': 'Оружие, ножи и перчатки',
  'premium.f2': 'Наклейки и брелоки',
  'premium.f3': 'Разные наборы для T и CT',
  'premium.matches_free': 'Играть в матчи можно бесплатно. Премиум нужен только для своих скинов.',
  'support.lead': 'Опишите проблему — мы получим обращение вместе с вашим аккаунтом.',
  'support.err.category': 'Выберите категорию',
  'support.err.subject': 'Тема должна содержать минимум 3 символа',
  'support.err.body': 'Опишите проблему подробнее — минимум 10 символов',
  'support.sent': 'Обращение отправлено',
  'support.ticket': 'Номер обращения',
  'support.after': 'Сохраните номер, если захотите сослаться на это обращение.',
  'support.another': 'Новое обращение',
  'support.category': 'Категория',
  'support.category_pick': 'Выберите категорию',
  'support.cat.account': 'Аккаунт и Steam',
  'support.cat.match': 'Матчи и сервер',
  'support.cat.skins': 'Скины',
  'support.cat.premium': 'Премиум и оплата',
  'support.cat.tech': 'Техническая проблема',
  'support.cat.other': 'Другое',
  'support.subject': 'Тема',
  'support.subject_placeholder': 'Например, не привязывается Steam',
  'support.body': 'Что произошло?',
  'support.body_placeholder': 'Опишите проблему и шаги, после которых она возникла.',
  'support.ctx.steam': 'Подключение Steam',
  'support.ctx.premium': 'Премиум и оплата',
  'support.ctx.match': 'Матч',
  'support.attach_context': 'Указать контекст: {name}',
  'support.no_secrets': 'Не отправляйте пароли, коды входа и платёжные данные.',
  'support.send': 'Отправить обращение',
  'auth.step': 'Шаг {n} из 2',
  'auth.step1': 'Укажите почту',
  'auth.step2': 'Подтвердите почту и задайте пароль',
  'auth.err.email': 'Введите корректный email',
  'auth.err.username': 'Введите имя игрока',
  'auth.err.code': 'Введите 6 цифр из письма',
  'auth.err.password': 'Введите пароль',
  'auth.err.password_long': 'Пароль не должен быть длиннее 72 символов',
  'auth.password_saved': 'Пароль сохранён',
  'auth.register.title': 'Создать аккаунт',
  'auth.reset.title': 'Восстановить пароль',
  'auth.register.lead': 'Начните с email или войдите через Steam.',
  'auth.reset.lead': 'Отправим код на почту, чтобы задать новый пароль.',
  'auth.username': 'Имя игрока',
  'auth.username_placeholder': 'Как вас будут знать в игре',
  'auth.get_code': 'Получить код',
  'auth.sending': 'Отправляем…',
  'auth.code_sent_to': 'Код отправлен на {email}.',
  'auth.change_email': 'Изменить почту',
  'auth.code': 'Код из письма',
  'auth.resend': 'Отправить ещё раз',
  'auth.resend_in': 'Повтор через {n} с',
  'auth.code_hint': 'Проверьте входящие и папку «Спам». Код действует 24 часа.',
  'auth.password': 'Пароль',
  'auth.new_password': 'Новый пароль',
  'auth.password_placeholder': 'Придумайте пароль',
  'auth.hide_password': 'Скрыть пароль',
  'auth.show_password': 'Показать пароль',
  'auth.password_rules': 'Не длиннее 72 символов. Рекомендуем от 8 символов с буквами и цифрами.',
  'auth.wait': 'Подождите…',
  'auth.save_password': 'Сохранить пароль',
  'auth.or_steam': 'или через игровой аккаунт',
  'auth.continue_steam': 'Продолжить со Steam',
  'auth.have_account': 'Уже есть аккаунт?',
  'auth.remembered': 'Вспомнили пароль?',
  'auth.sign_in': 'Войти',
  'auth.terms_prefix': 'Создавая аккаунт, вы принимаете',
  'auth.terms': 'условия использования',
  'auth.and': 'и',
  'auth.privacy': 'политику конфиденциальности',
  'auth.login.title': 'Вход в аккаунт',
  'auth.login.lead': 'Войдите по email или через Steam.',
  'auth.password_enter': 'Введите пароль',
  'auth.forgot': 'Забыли пароль?',
  'auth.signing_in': 'Входим…',
  'auth.or': 'или',
  'auth.login.steam': 'Войти через Steam',
  'auth.no_account': 'Нет аккаунта?',
  'legal.footer_label': 'Документы и контакты',
  'legal.terms': 'Пользовательское соглашение',
  'legal.privacy': 'Политика конфиденциальности',
  'legal.consent': 'Согласие на обработку ПД',
  'legal.cookie': 'Политика cookie',
  'legal.doc_new_tab': 'откроется в новой вкладке',
  'auth.agree_terms_prefix': 'Я принимаю',
  'auth.agree_terms_and': 'и ознакомлен(а) с',
  'auth.agree_pd_prefix': 'Я даю',
  'auth.agree_pd_suffix': 'на обработку моих персональных данных',
  'auth.err.consent_terms': 'Подтвердите принятие соглашения и ознакомление с политикой',
  'auth.err.consent_pd': 'Подтвердите согласие на обработку персональных данных',
  'auth.err.consent_required': 'Для регистрации нужно принять соглашение и дать согласие на обработку персональных данных',
  'steam.consent.title': 'Нужно согласие для регистрации',
  'steam.consent.text': 'Этот Steam-аккаунт ещё не зарегистрирован. Отметьте согласия на странице регистрации и повторите вход через Steam.',
  'legal.to_register': 'Перейти к регистрации',
  'home.level': 'Уровень {n}',
  'home.to_level': 'До {n} уровня: {elo} ELO',
  'home.max_level': 'Максимальный уровень',
  'home.elo': 'ELO',
  'home.mode_label': 'Режим',
  'home.team_size': 'Состав',
  'home.you': 'Вы',
  'home.invite_slot_hint': 'Свободное место',
  'home.invite_sent': 'Приглашение отправлено',
  'home.invited': 'Приглашён',
  'home.solo_ok': 'Можно играть одному',
  'home.reason.steam': 'Подключите Steam, чтобы участвовать в матчах',
  'home.reason.member_steam': 'У игрока {name} не привязан Steam.',
  'home.reason.not_ready': 'Ждём готовность игроков: {names}',
  'home.reason.sync': 'Обновляем состояние…',
  'home.reason.leader_only': 'Поиск запускает лидер',
  'home.ready_all': 'Всё готово к поиску',
  'home.searching_hint': 'Не закрывайте эту страницу, чтобы сразу перейти к матчу',
  'home.searching_member': 'Лидер ищет матч для команды',
  'home.check.steam': 'Steam',
  'home.check.gameguard': 'GameGuard',
  'home.check.team': 'Команда',
  'home.check.linked': 'привязан',
  'home.check.link': 'Привязать',
  'home.check.download': 'Скачать',
  'home.check.unverifiable': 'Проверка вручную',
  'home.check.fix': 'Исправить',
  'home.friends_online': '{n} в сети',
  'home.searching_players': 'Ищем игроков…',
  'home.search_clear': 'Очистить поиск',
  'home.friend_pending': 'Запрос отправлен',
  'home.friend_already': 'Уже в друзьях',
  'home.friends_empty_title': 'Пока никого нет',
  'home.friends_empty_text': 'Найдите напарников по нику и добавьте в друзья — они появятся здесь и смогут играть с вами в одной команде.',
  'home.friends_empty_cta': 'Найти игрока',
  'home.friends_load_error': 'Не удалось загрузить друзей',
  'home.view_profile': 'Профиль',
  'home.invitation_from': 'Приглашение в команду',
  'home.friends_hint_short': 'Приглашать можно только друзей',
  'nav.help': 'Помощь и загрузки',
  'nav.subscription': 'Premium',
  'header.subscription': 'Premium',
  'header.settings': 'Настройки',
  'header.language': 'Язык',
  'lang.ru': 'Русский',
  'lang.en': 'English',
  'common.open_menu': 'Открыть меню',
  'home.unready': 'Снять готовность',
  'home.open_slot': 'Свободно',
  'home.invite_short': 'Пригласить',
  'home.gameguard_note': 'Для игры нужен GameGuard, сайт не проверяет его установку',
  'home.gameguard_download': 'Скачать GameGuard',
  'home.more_reasons': 'Ещё {n}',
  'home.reasons_hide': 'Скрыть',
  'home.kick_title': 'Исключить игрока {name}?',
  'home.kick_text': 'Игрок покинет команду. Вернуться он сможет только по новому приглашению.',
  'home.member_actions': 'Действия: {name}',
  'home.recent': 'Последние матчи',
  'home.all_matches': 'Все матчи',
  'home.map_pending': 'Карта выбирается',
  'home.state.waiting': 'Выбор карты',
  'home.state.cancelled': 'Отменён',
  'home.level_short': 'Ур. {n}',
  'home.friends_open': 'Друзья',
  'home.friends_sheet': 'Друзья и приглашения',
  'home.loading_team': 'Загружаем команду',
  'home.party_full': 'В команде нет свободных мест',
  'home.in_team': 'В команде',
  'home.search_players_label': 'Найти игрока по нику',
  'home.invite_slots': 'Свободных мест: {n}',
  'home.friend_incoming': 'Запрос получен',
  'home.friend_in_party': 'В команде',
  'home.invite_full': 'В команде нет свободных мест',
  'home.invite_searching': 'Идёт поиск матча',
  'home.online_count': '{n} в сети',
  'home.row_actions': 'Действия: {name}',
  'home.accept_short': 'Принять',
  'home.decline_short': 'Отклонить',
  'home.friends_in_friends': 'В друзьях',
  'home.remove_title_named': 'Удалить {name} из друзей?',
  'stats.no_data': 'Нет данных',
  'stats.kpi_matches_hint': 'Завершённые матчи',
  'stats.current_elo': 'Текущий ELO',
  'stats.current_elo_hint': 'Не зависит от фильтров',
  'stats.winrate_hint': 'По завершённым матчам',
  'stats.kd_hint': 'Убийства к смертям',
  'stats.filters_btn': 'Фильтры',
  'stats.elo_note': 'Рассчитано по итогам завершённых матчей без ничьих',
  'stats.single_point': 'Одно наблюдение: {elo} ELO, {date}',
  'stats.outcomes': 'Исходы',
  'stats.maps_title': 'Карты',
  'stats.maps_hint': 'Завершённые матчи по картам',
  'stats.activity_title': 'Активность по дням',
  'stats.activity_hint': 'Матчей за день, показаны только дни с играми',
  'stats.matches_unit': 'матчей',
  'stats.empty_title': 'Матчей пока нет',
  'stats.empty_text': 'Результат первого завершённого матча появится здесь. Сейчас ваш рейтинг — {elo} ELO.',
  'stats.empty_cta': 'Перейти к игре',
  'stats.remove_filter': 'Убрать фильтр: {name}',
  'stats.reset_filters': 'Сбросить фильтры',
  'stats.table.search_placeholder': 'Карта или режим',
  'stats.history_scope': 'История по выбранным условиям',
  'stats.filtered_empty': 'По этим условиям ничего не найдено',
  'stats.updating': 'Обновляем…',
  'stats.small_sample': 'малая выборка',
  'stats.dur_unknown': 'длительность неизвестна',
  'stats.wins_short': 'Победы',
  'stats.losses_short': 'Поражения',
  'stats.draws_short': 'Ничьи',
  'stats.outcome_of': 'из {n} завершённых',
  'stats.period_label': 'Период',
  'stats.elo_chart_title': 'Динамика ELO',
  'stats.legend_elo': 'ELO',
  'stats.show_results': 'Показать: {n}',
  'skins.more_actions': 'Ещё действия: {name}',
  'skins.delete_title_named': 'Удалить {name} из набора CS Hub?',
  'skins.set_note': 'Ваш арсенал для матчей CS Hub: предметы, стороны, наклейки и брелки.',
  'skins.no_results_title': 'По этим условиям ничего не найдено',
  'skins.no_results_text': 'Измените поиск или сбросьте фильтры — предметы и экипировка при этом не затрагиваются.',
  'skins.kind_empty_title': 'В наборе пока нет {kind}.',
  'skins.kind_empty_text': 'Добавьте предмет этого типа из каталога.',
  'skins.premium_title': 'Скины доступны с Premium',
  'skins.premium_text': 'Premium открывает собственный набор для T и CT. Играть в матчи можно и без него.',
  'skins.premium_cta': 'Перейти к Premium',
  'skins.kind_plural.weapon': 'оружия',
  'skins.kind_plural.knife': 'ножей',
  'skins.kind_plural.glove': 'перчаток',
  'skins.configure_named': 'Настроить: {name}',
  'skins.configure_short': 'Настроить',
  'profile.settings_btn': 'Настройки профиля',
  'profile.settings_title': 'Настройки профиля',
  'profile.back': 'К профилю',
  'profile.nav': 'Разделы профиля',
  'profile.nav_overview': 'Обзор',
  'profile.nav_settings': 'Настройки',
  'profile.stats.draws': 'Ничьи',
  'profile.newbie_title': 'Статистика появится после первого завершённого матча',
  'profile.newbie_text': 'Стартовый рейтинг уже на месте. Сыграйте матч, и результаты появятся здесь.',
  'profile.to_game': 'Перейти к игре',
  'profile.indicators': 'Игровые показатели',
  'profile.favorite_map': 'Карта с лучшим результатом',
  'profile.no_data': 'Нет данных',
  'profile.recent': 'Последние матчи',
  'profile.full_stats': 'Подробная статистика',
  'profile.appearance': 'Внешний вид',
  'profile.account': 'Аккаунт',
  'profile.username_label': 'Ник',
  'profile.avatar_label': 'Аватар',
  'profile.background_label': 'Фон профиля',
  'profile.replace': 'Заменить',
  'profile.choose': 'Выбрать файл',
  'profile.drop_hint': 'или перетащите файл сюда',
  'profile.file_hint': 'JPG, PNG или GIF, до 3 МБ',
  'profile.err_type': 'Подходят только JPG, PNG и GIF',
  'profile.err_size': 'Файл больше 3 МБ',
  'profile.err_read': 'Не удалось прочитать файл',
  'profile.saved': 'Изменения сохранены',
  'profile.discard': 'Отменить',
  'profile.save': 'Сохранить',
  'profile.unsaved': 'Есть несохранённые изменения',
  'profile.no_background': 'Фон не задан',
  'profile.preview': 'Предпросмотр',
  'profile.leave_warn': 'Есть несохранённые изменения. Закрыть страницу?',
  'account.email': 'Email',
  'account.email_none': 'Email не указан',
  'account.steam': 'Steam',
  'account.steam_linked': 'Подключён',
  'account.steam_link': 'Привязать Steam',
  'account.clan_tag': 'Показывать тег клана в игре',
  'account.clan_tag_hint': 'Влияет только на отображение ника в матчах',
  'account.change_email': 'Сменить email',
  'account.change_password': 'Сменить пароль',
  'account.set_password': 'Установить пароль',
  'account.new_email': 'Новый email',
  'account.new_password': 'Новый пароль',
  'account.code': 'Код подтверждения',
  'account.get_code': 'Получить код',
  'account.resend_code': 'Отправить код снова',
  'account.code_sent': 'Код отправлен на {email}. Он действует 24 часа.',
  'account.confirm': 'Подтвердить',
  'account.show_password': 'Показать пароль',
  'account.hide_password': 'Скрыть пароль',
  'account.saved_email': 'Email изменён',
  'account.saved_password': 'Пароль изменён',
  'account.setting_saved': 'Настройка сохранена',
  'account.err_email': 'Введите корректный email',
  'account.err_password': 'Введите новый пароль',
  'account.err_code': 'Введите код из письма',
  'account.sent_new': 'Код придёт на новую почту.',
  'account.sent_account': 'Код придёт на почту аккаунта.',
  'account.close': 'Закрыть',
  'pp.not_found_text': 'Профиля с таким идентификатором нет. Возможно, ссылка устарела.',
  'pp.forbidden': 'Профиль недоступен',
  'pp.forbidden_text': 'У вас нет доступа к этому профилю.',
  'pp.load_failed': 'Не удалось загрузить профиль',
  'pp.load_failed_text': 'Это временный сбой, а не отсутствие игрока. Попробуйте ещё раз.',
  'pp.no_stats': 'Публичной статистики пока нет.',
  'cl.members_n': '{n} из {max}',
  'cl.members_label': 'участников',
  'cl.winrate': 'побед',
  'cl.avg_elo': 'ср. ELO {n}',
  'cl.private': 'Закрытый',
  'cl.invite_only': 'Только по приглашению',
  'cl.by_request': 'Вступление по заявке',
  'cl.free_join': 'Свободное вступление',
  'cl.requirements': 'Требования',
  'cl.req_level': 'уровень от {n}',
  'cl.req_elo': 'ELO от {n}',
  'cl.req_winrate': 'побед от {n}%',
  'cl.req_games': 'игр от {n}',
  'cl.req_none': 'Без требований',
  'cl.details': 'Подробнее',
  'cl.join': 'Вступить',
  'cl.apply': 'Подать заявку',
  'cl.applied': 'Заявка отправлена',
  'cl.full': 'Нет мест',
  'cl.your_clan': 'Ваш клан',
  'cl.in_other': 'Вы уже в клане',
  'cl.empty_find': 'Кланы не найдены',
  'cl.empty_find_text': 'Измените запрос или сбросьте поиск.',
  'cl.empty_dir': 'Кланов пока нет',
  'cl.empty_dir_text': 'Создайте первый клан — другие игроки смогут к нему присоединиться.',
  'cl.role_leader': 'Лидер',
  'cl.role_member': 'Участник',
  'cl.you': 'Вы',
  'cl.created': 'Создан {date}',
  'cl.led_by': 'Лидер: {name}',
  'cl.edit': 'Редактировать',
  'cl.leave': 'Покинуть клан',
  'cl.disband': 'Распустить клан',
  'cl.invite': 'Пригласить',
  'cl.invite_title': 'Пригласить игрока',
  'cl.invite_placeholder': 'Ник или email игрока',
  'cl.requests': 'Заявки на вступление',
  'cl.requests_none': 'Новых заявок нет',
  'cl.accept': 'Принять',
  'cl.decline': 'Отклонить',
  'cl.members': 'Участники',
  'cl.kick': 'Исключить',
  'cl.stat_members': 'Участников',
  'cl.stat_winrate': 'Побед',
  'cl.stat_matches': 'Матчей у участника (среднее)',
  'cl.stat_elo': 'Средний ELO',
  'cl.rules_join': 'Правила вступления',
  'cl.links': 'Ссылки',
  'cl.rules': 'Правила клана',
  'cl.no_clan': 'Вы не состоите в клане',
  'cl.no_clan_text': 'Найдите клан по вкусу или создайте свой.',
  'cl.find': 'Найти клан',
  'cl.create': 'Создать клан',
  'cl.inv_none': 'Приглашений нет',
  'cl.inv_none_text': 'Когда клан пригласит вас, приглашение появится здесь.',
  'cl.inv_from': 'Приглашает {name}',
  'cl.inv_expires': 'Действует до {date}',
  'cl.inv_expired': 'Срок истёк',
  'cl.to_overview': 'К обзору кланов',
  'cl.leader': 'Лидер',
  'cl.type': 'Тип',
  'cl.type_public': 'Открытый',
  'cl.type_private': 'Закрытый',
  'cl.max_members': 'Максимум участников',
  'cl.approval_yes': 'Заявки одобряет лидер',
  'cl.approval_no': 'Вступление без одобрения',
  'cl.members_invite_yes': 'Участники могут приглашать',
  'cl.members_invite_no': 'Приглашает только лидер',
  'cl.close': 'Закрыть',
  'cl.member_actions': 'Действия: {name}',
  'cl.level_short': 'Ур. {n}',
  'cl.open_link_discord': 'Discord',
  'cl.open_link_site': 'Сайт',
  'cl.search_clear': 'Сбросить поиск',
  'cl.no_desc': 'Описание не указано',
  'cl.invite_sent': 'Приглашение отправлено',
  'premium.sub': 'Свои наборы скинов для T и CT. Играть в матчи можно и без Premium.',
  'premium.per_month': '{amount} в месяц',
  'premium.promo_check': 'Проверить',
  'premium.promo_checking': 'Проверяем…',
  'premium.promo_valid': 'Скидка {n}%',
  'premium.promo_invalid': 'Промокод не найден или неактивен',
  'premium.unavailable': 'Оплата временно недоступна',
  'premium.unavailable_text': 'Выбранный срок и промокод сохранены. Попробуйте позже или напишите в поддержку.',
  'premium.config_error': 'Не удалось получить цены',
  'premium.adds_to_current': 'Новый срок добавится к текущему окончанию.',
  'premium.new_until': 'После оплаты Premium будет действовать до {date}',
  'premium.retry': 'Повторить',
  'premium.base_price': 'Без скидки',
  'support.copy': 'Скопировать',
  'support.copied': 'Скопировано',
  'support.new': 'Новое обращение',
  'support.memo_title': 'Что указать',
  'support.memo_1': 'Что вы делали и что ожидали увидеть',
  'support.memo_2': 'Что произошло на самом деле',
  'support.memo_3': 'Номер матча или название предмета, если это важно',
  'support.send_failed': 'Не удалось отправить обращение. Текст сохранён — попробуйте ещё раз.',
  'support.counter': '{n} из 2000',
  'match.title_veto': 'Выбор карты',
  'match.turn_of': 'Ходит {team}',
  'match.time_left': 'Осталось',
  'match.your_vote': 'Ваш голос',
  'match.votes_n': 'Голосов: {n}',
  'match.wait_turn': 'Ход другой команды',
  'match.finished': 'Матч завершён',
  'match.cancelled': 'Матч отменён',
  'match.reason_label': 'Причина: {text}',
  'match.start_failed': 'Не удалось запустить матч',
  'match.start_failed_text': 'Сервер матча сейчас недоступен. Вернитесь к игре и начните поиск заново.',
  'match.not_found': 'Матч не найден',
  'match.not_found_text': 'Такого матча нет, возможно, ссылка устарела.',
  'match.leave_title': 'Выйти и отменить матч?',
  'match.leave_text': 'Вы покинете команду, а матч будет отменён для всех участников.',
  'match.leave_confirm': 'Выйти и отменить',
  'match.connect_title': 'Подключение',
  'match.sync_lost': 'Нет связи с сервером. Показаны последние полученные данные.',
  'match.stats_head': 'У / С / П',
  'match.stats_hint': 'Убийства / смерти / помощь',
  'match.members_n': '{n} игроков',
  'match.player_actions': 'Действия: {name}',
  'match.map_unknown': 'Карта выбирается',
  'match.connect_hint': 'Данные видны только участникам матча.',
  'match.retry': 'Повторить',
  'land.eyebrow': 'Counter-Strike 2 · 5×5',
  'land.h1': 'Твой следующий раунд',
  'land.sub': 'Соревновательные матчи 5×5 с командой или в одиночку, рейтинг ELO и свой набор скинов.',
  'land.cta': 'Начать играть',
  'land.cta_in': 'Перейти к игре',
  'land.login': 'Вход',
  'land.register': 'Создать аккаунт',
  'land.download': 'Скачать GameGuard',
  'land.b1_title': 'Матч за несколько минут',
  'land.b1_text': 'Соберите группу до пяти игроков или играйте один. Лидер запускает поиск, участники подтверждают готовность, затем команды выбирают карту и подключаются к серверу.',
  'land.b1_li1': 'Приглашения друзьям прямо из лобби',
  'land.b1_li2': 'Выбор карты голосованием перед матчем',
  'land.b1_li3': 'Данные подключения только участникам матча',
  'land.b2_title': 'Рейтинг и вся история',
  'land.b2_text': 'ELO и уровень, K/D, процент побед, динамика рейтинга по матчам и полная история с экспортом страницы.',
  'land.b2_li1': 'Фильтры по карте, периоду и результату',
  'land.b2_li2': 'Профиль игрока и друзья в одном месте',
  'land.b2_li3': 'Кланы с заявками и приглашениями',
  'land.b3_title': 'Свой набор скинов',
  'land.b3_text': 'Premium открывает собственные наборы для T и CT: оружие, ножи, перчатки, наклейки и брелоки. Играть в матчи можно бесплатно.',
  'land.steps_title': 'С чего начать',
  'land.step1': 'Создайте аккаунт или войдите через Steam',
  'land.step2': 'Привяжите Steam',
  'land.step3': 'Установите GameGuard — он нужен для игры в матчах',
  'land.step4': 'Соберите группу или играйте один и запустите поиск',
  'land.maps_title': 'Карты',
  'land.maps_text': 'Соревновательные карты CS2. Карта конкретного матча выбирается перед игрой.',
  'land.final_title': 'Готовы к матчу?',
  'land.final_text': 'Создайте аккаунт и найдите первую игру.',
  'land.terms': 'Условия',
  'land.privacy': 'Конфиденциальность',
  'land.motion_pause': 'Приостановить анимацию',
  'land.motion_play': 'Продолжить анимацию',
  'auth.back_home': 'На главную',
  'auth.story_1': 'Твоя команда.',
  'auth.story_2': 'Твой раунд.',
  'auth.err.invalid_credentials': 'Неверная почта или пароль',
  'auth.err.network': 'Не удалось связаться с сервером. Попробуйте ещё раз.',
  'auth.err.email_taken': 'Аккаунт с такой почтой уже есть',
  'auth.err.too_many': 'Слишком много попыток. Подождите и повторите.',
  'land.b2_f1': 'Уровень и рейтинг',
  'land.b2_f2': 'Убийства к смертям',
  'land.b2_f3': 'По завершённым матчам',
  'land.b2_f4': 'Карта, счёт и состав',
  'adm.platform': 'К платформе',
  'adm.nav': 'Администрирование',
  'adm.overview': 'Обзор',
  'adm.users': 'Пользователи',
  'adm.maps': 'Карты',
  'adm.subscriptions': 'Подписки',
  'adm.finance': 'Финансы',
  'adm.moderation': 'Модерация',
  'adm.analytics': 'Аналитика',
  'adm.settings': 'Настройки',
  'adm.support': 'Обращения',
  'adm.refresh': 'Обновить',
  'adm.export_page': 'Экспорт страницы',
  'adm.details': 'Подробнее',
  'adm.close': 'Закрыть',
  'adm.retry': 'Повторить',
  'adm.loading': 'Загрузка…',
  'adm.load_error': 'Не удалось загрузить данные',
  'adm.total': 'Всего: {n}',
  'adm.search_users': 'Поиск по нику или email',
  'adm.col_user': 'Пользователь',
  'adm.col_profile': 'Игровой профиль',
  'adm.col_sub': 'Подписка',
  'adm.col_role': 'Роль',
  'adm.col_reg': 'Регистрация',
  'adm.premium_on': 'Premium активен',
  'adm.premium_off': 'Нет',
  'adm.role_admin': 'Администратор',
  'adm.role_user': 'Игрок',
  'adm.no_email': 'Email не указан',
  'adm.no_users': 'Пользователи не найдены',
  'adm.copy_id': 'Скопировать ID',
  'adm.copied': 'ID скопирован',
  'adm.user_note': 'Просмотр. Изменение аккаунтов из панели недоступно: на сервере нет таких операций.',
  'adm.level': 'Уровень {n}',
  'adm.id': 'ID',
  'adm.maps_add': 'Добавить карту',
  'adm.maps_edit': 'Изменить',
  'adm.maps_activate': 'Активировать',
  'adm.maps_delete': 'Удалить',
  'adm.maps_empty': 'Карт пока нет',
  'adm.maps_search': 'Поиск по карте',
  'adm.map_name': 'Идентификатор (de_mirage)',
  'adm.map_display': 'Название',
  'adm.map_desc': 'Описание',
  'adm.map_image': 'Ссылка на изображение',
  'adm.map_workshop': 'Workshop ID',
  'adm.map_category': 'Категория',
  'adm.map_status': 'Статус',
  'adm.map_min': 'Минимум игроков',
  'adm.map_max': 'Максимум игроков',
  'adm.map_official': 'Официальная карта',
  'adm.map_saved': 'Карта сохранена',
  'adm.map_deleted': 'Карта удалена',
  'adm.map_required': 'Укажите идентификатор и название',
  'adm.map_delete_title': 'Удалить карту {name}?',
  'adm.map_delete_text': 'Карта будет удалена из базы. Если она используется, сервер откажет.',
  'adm.cat.main': 'Основная',
  'adm.cat.reserve': 'Резервная',
  'adm.cat.premium': 'Premium',
  'adm.cat.custom': 'Своя',
  'adm.st.active': 'Активна',
  'adm.st.inactive': 'Отключена',
  'adm.st.pending': 'Ожидает',
  'adm.mod_filter': 'Состояние',
  'adm.mod_all': 'Все',
  'adm.mod_empty': 'Жалоб нет',
  'adm.mod_from': 'Автор: {id}',
  'adm.mod_open': 'Новая',
  'adm.mod_progress': 'В работе',
  'adm.mod_closed': 'Закрыта',
  'adm.mod_to_progress': 'Взять в работу',
  'adm.mod_close': 'Закрыть жалобу',
  'adm.mod_updated': 'Статус обновлён',
  'adm.mod_reason': 'Причина',
  'adm.mod_note': 'Жалоба — это сообщение пользователя, а не вывод о нарушении.',
  'adm.sup_empty': 'Обращений нет',
  'adm.sup_search': 'Поиск по теме, автору и тексту',
  'adm.sup_scope': 'Показаны последние обращения (до 100).',
  'adm.sup_number': '№ {n}',
  'adm.sup_pick': 'Выберите обращение',
  'adm.sup_back': 'К списку',
  'adm.ov_users': 'Пользователей',
  'adm.ov_maps': 'Карт в базе',
  'adm.ov_complaints': 'Новых жалоб',
  'adm.ov_tickets': 'Обращений',
  'adm.ov_scope_tickets': 'в последней выборке (до 100)',
  'adm.ov_recent': 'Последние обращения',
  'adm.ov_recent_complaints': 'Последние жалобы',
  'adm.ov_open': 'Открыть',
  'adm.na_title': 'Раздел не подключён к данным',
  'adm.na_text': 'На сервере нет API для этого раздела, поэтому значения не показываются: демонстрационные цифры нельзя выдавать за реальные.',
  'adm.na_subscriptions': 'Список подписок и операции над ними пока не поддерживаются сервером. Статус Premium виден в разделе «Пользователи».',
  'adm.na_finance': 'Платежи Premium создаются в системе оплаты, но административного API для их просмотра нет.',
  'adm.na_analytics': 'Агрегированной аналитики на сервере нет.',
  'adm.na_settings': 'Настройки платформы на сервере не хранятся; параметры задаются конфигурацией окружения.',
  'match.team_named': 'Команда {name}',
  'sys.not_found': 'Страница не найдена',
  'sys.not_found_text': 'Такого адреса нет. Возможно, ссылка устарела или в ней опечатка.',
  'sys.to_start': 'На главную страницу',
  'sys.forbidden': 'Нет доступа',
  'sys.forbidden_text': 'Этот раздел доступен только администраторам платформы.',
  'sys.temporary': 'Сервис временно недоступен. Попробуйте ещё раз.',
  'cl.dir_error': 'Не удалось загрузить список кланов',
  'premium.promo_check_failed': 'Не удалось проверить промокод. Попробуйте ещё раз.',
  'skins.reset_all': 'Сбросить всё',
  'skins.installed': 'Выбрано',
  'skins.editor_title': 'Настройка предмета',
  'skins.found_of': 'Найдено {n} из {total}',
  'skins.view_label': 'Просмотр',
  'skins.view_t': 'За T',
  'skins.view_ct': 'За CT',
  'skins.status_t': 'Экипирован за T',
  'skins.status_ct': 'Экипирован за CT',
  'skins.status_none': 'Не экипирован',
  'skins.equip': 'Экипировать',
  'skins.equip_menu': 'Экипировка',
  'skins.equip_menu_title': 'Экипировка: {name}',
  'skins.equip_now': 'Сейчас за {side}: {name}',
  'skins.equip_none_now': 'За {side} сейчас ничего не экипировано',
  'skins.equip_action': 'Действие: экипировать {name}',
  'skins.equip_for': 'Экипировать за {side}',
  'skins.unequip_for': 'Снять за {side}',
  'skins.equip_this': 'Экипирован за {side}',
  'skins.equip_incompatible': 'Недоступно за {side}',
  'skins.equipped_toast': '{name} экипирован за {side}',
  'skins.unequipped_toast': '{name} снят за {side}',
  'skins.equip_error': 'Не удалось сохранить. Прежняя экипировка не изменилась.',
  'skins.equip_saving': 'Сохраняем…',
  'skins.wear_unset': 'Не указано',
  'skins.pane_params': 'Параметры',
  'skins.pane_deco': 'Украшения',
  'skins.slot_current': 'Установлено: {name}',
  'skins.slot_empty': 'Слот пуст',
  'skins.slot_pick_hint': 'Выберите украшение в каталоге ниже.',
  'skins.slot_replace_hint': 'Чтобы заменить, выберите другое украшение ниже.',
  'skins.slot_clear': 'Убрать из слота',
  'skins.slot_active': 'Выбран',
  'skins.equip_draft_note': 'Изменится после сохранения',
  'skins.side_t_name': 'Террористы · T',
  'skins.side_ct_name': 'Спецназ · CT',
  'skins.empty_deco': 'Без украшений',
  'skins.draft_replaces': 'Сейчас за {side}: {name}. Будет заменён после сохранения.',
  'skins.equipped_replaced_toast': '{name} экипирован за {side}. {other} остаётся в инвентаре',
  'nav.referral': 'Рефералка',
  'ref.title': 'Рефералка',
  'ref.sub': 'Приглашайте друзей и получайте скидку на Premium.',
  'ref.hero.title': 'Приглашайте друзей — платите за Premium меньше',
  'ref.hero.text': 'Друг регистрируется по вашей ссылке и играет. За каждый его завершённый матч вы получаете 1 балл. {n} баллов — скидка {pct}% на подписку.',
  'ref.link': 'Ваша ссылка',
  'ref.copy': 'Копировать',
  'ref.copied': 'Ссылка скопирована',
  'ref.copy_failed': 'Не удалось скопировать — выделите ссылку вручную',
  'ref.share': 'Поделиться',
  'ref.share_text': 'Играй со мной в CS Hub',
  'ref.code': 'Код',
  'ref.invited': 'Приглашено',
  'ref.invited_hint': 'зарегистрировались по ссылке',
  'ref.matches': 'Матчей сыграно',
  'ref.matches_hint': 'всего у приглашённых',
  'ref.points': 'Ваши баллы',
  'ref.points_hint': '1 матч = 1 балл',
  'ref.progress': 'До максимальной скидки {pct}% осталось {n} баллов',
  'ref.progress_full': 'Максимальная скидка {pct}% доступна',
  'ref.discount_now': 'Сейчас можно получить скидку {pct}%',
  'ref.use': 'Потратить на Premium',
  'ref.how': 'Как это работает',
  'ref.step1.title': 'Отправьте ссылку',
  'ref.step1.text': 'Друг регистрируется по вашей ссылке.',
  'ref.step2.title': 'Друг играет',
  'ref.step2.text': 'Каждый его завершённый матч приносит вам 1 балл.',
  'ref.step3.title': 'Платите меньше',
  'ref.step3.text': '{n} баллов — скидка {pct}% на Premium. Суммируется с промокодом.',
  'ref.list': 'Приглашённые',
  'ref.list_matches': '{n} матчей',
  'ref.empty.title': 'Пока никого нет',
  'ref.empty.text': 'Отправьте ссылку другу — он появится здесь после регистрации.',
  'ref.error': 'Не удалось загрузить рефералку',
  'ref.retry': 'Повторить',
  'ref.banner.title': 'Пригласи друзей, получи скидку на подписку',
  'ref.banner.text': '1 балл за каждый матч друга. {n} баллов дают скидку {pct}% на Premium.',
  'ref.banner.cta': 'Пригласить друзей',
  'premium.points.title': 'Баллы за приглашения',
  'premium.points.balance': 'У вас {n} баллов',
  'premium.points.use': 'Списать {n} баллов — скидка {pct}%',
  'premium.points.none': 'Приглашайте друзей: {n} баллов — скидка {pct}%',
  'premium.points.invite': 'Как получить баллы',
  'premium.points.applied': 'Спишется {n} баллов · скидка {pct}%',
  'premium.points.changed': 'Баланс баллов изменился. Проверьте итог и повторите оплату.',
  'premium.part_promo': 'Промокод −{n}%',
  'premium.part_points': 'Баллы −{n}%',
  'premium.you_save': 'Экономия {amount}',
};
